<template>
  <div :id="id" class="tab-content w-full bg-white shadow-md rounded-lg p-6 mt-6">
    <div class="grid">
      <h2 class="text-xl font-medium">Pengaturan</h2>
      <PercentBadgeIcon class="h-5 w-5 text-gray-400 invisible" />
      <InputTextWithIcon id="setting-tax" v-model="tax" input_class="flex-1" label="Tax"
        label_class="mb-1 block text-start" type="number" placeholder="Masukkan tax" :icon-right="icon"
        :valid="validation.tax.valid" :error-message="validation.tax.message" />
      <InputTextWithIcon id="setting-service-charge" v-model="service_charge" input_class="flex-1"
        label="Service Charge" label_class="mb-1 block text-start" type="number" placeholder="Masukkan service charge"
        :icon-right="icon" :valid="validation.service_charge.valid"
        :error-message="validation.service_charge.message" />
      <InputTextCustom v-model="pin" id="setting-pin" label="PIN" placeholder="Masukkan PIN"
        :valid="validation.pin_code.valid" :error-message="validation.pin_code.message"/>
      <div class="flex items-center my-3">
        <Button type="submit" label="Posting" :loading="loading" @click="saveSettings" />
      </div>
    </div>
  </div>
</template>

<script>
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import InputTextWithIcon from '@/components/form/InputTextWithIcon.vue';
import Button from 'primevue/button';
import { PercentBadgeIcon } from '@heroicons/vue/24/solid';
import { mapGetters } from 'vuex';

export default {
  name: "Pengaturan_2",
  props: {
    id: String
  },
  components: {
    InputTextWithIcon, PercentBadgeIcon, InputTextCustom, Button
  },
  data() {
    return {
      loading: false,
      tax: 0,
      service_charge: 0,
      pin: '',
      icon: PercentBadgeIcon,
      validation: {
        tax: {
          valid: true,
          message: ''
        },
        service_charge: {
          valid: true,
          message: ''
        },
        pin_code: {
          valid: true,
          message: ''
        }
      },
      field: ['tax', 'service_charge', 'pin_code'],
    };
  },
  computed: {
    ...mapGetters('settings', ['allSettings']),
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      await this.$store.dispatch('settings/fetchSettings');
      let relevantSettings = {};
      if (this.allSettings.length > 0) {
        relevantSettings = this.allSettings[0];
        this.tax = relevantSettings.tax;
        this.service_charge = relevantSettings.service_charge;
        this.pin = relevantSettings.pin_code;
      } else {
        //
      }
    },
    saveSettings() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan pengaturan?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postSetting();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan pengaturan', life: 3000 });
        }
      });
    },
    async postSetting() {
      try {
        this.loading = true;
        let relevantSettings = {};
        if (this.allSettings.length > 0) {
          relevantSettings = this.allSettings[0];
          await this.$store.dispatch('settings/updateSetting', {
            id: relevantSettings.id,
            tax: this.tax,
            service_charge: this.service_charge,
            discount: 0,
            pin_code: this.pin,
          });
        } else {
          await this.$store.dispatch('settings/createSetting', {
            tax: this.tax,
            service_charge: this.service_charge,
            discount: 0,
            pin_code: this.pin,
          });
        }
        this.fetchSettings();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Pengaturan berhasil disimpan', life: 5000 });
      } catch (error) {
        console.error('Failed to save setting:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>